import { Dialog } from '@material-ui/core';
import { Alert } from 'assets/icons';
import { t } from 'i18next';
import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import DialogCard from 'shared/components/dialog/dialogCard';
import Button from 'shared/components/form/button';
import { APP_URL } from 'shared/constants/common';

interface Props {
	isOpen: boolean;
	setDialogClose: () => void;
}

const PlayerProfileDialog: FC<Props> = ({ isOpen, setDialogClose }) => {
	const history = useHistory();

	const handleRedirection = () => {
		history.push(APP_URL.aplikacjaMobilna);
		setDialogClose();
	};
	return (
		<div>
			<Dialog
				maxWidth="xs"
				fullWidth
				onClose={() => {}}
				className="custom-dialog bg--transparent custom--box-shadow text--center"
				aria-labelledby="customized-dialog"
				open={isOpen}
			>
				<DialogCard
					className="info--card"
					icon={() => <Alert className="modal--icon lock--icon" />}
					subDescription={t('notAvailableDialogInfo')}
					cardBottomCustom={
						<div className="card__bottom card__bottom_multi-btn">
							<Button btnType="dialog-info-cancel" onClick={setDialogClose}>
								{t('ok')}
							</Button>
							<Button btnType="dialog-info-accept" onClick={() => handleRedirection()}>
								{t('downloadApp')}
							</Button>
						</div>
					}
				/>
			</Dialog>
		</div>
	);
};

export default PlayerProfileDialog;
